import { NodeSpec } from 'prosemirror-model';

import { Video } from '@lyearn/lygo-blocks';

export default class LyVideoRestrictedForwarding extends Video {
  get schema(): NodeSpec {
    let parentSchema = super.schema;
    if (parentSchema?.attrs?.allowForwarding?.default) {
      parentSchema.attrs.allowForwarding.default = false;
    }
    return parentSchema;
  }
}
